import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import _forEach from "lodash/forEach";
export default {
  name: 'EnterAnimate',
  props: {
    cls: {
      type: String,
      default: 'transparent downup'
    },
    once: {
      type: Boolean,
      default: true
    },
    threshold: {
      type: Array,
      default: function _default() {
        return [0, 1];
      }
    }
  },
  data: function data() {
    return {
      observer: null,
      visible: false
    };
  },
  mounted: function mounted() {
    this.init();
    window.addEventListener('resize', this.init);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.init);
  },
  methods: {
    init: function init() {
      var _this = this;

      if (typeof IntersectionObserver !== 'undefined') {
        this.observer = new IntersectionObserver(function (entries) {
          _forEach(entries, function (entry) {
            _this.visible = entry.isIntersecting;

            if (_this.visible === true && _this.once === true && _this.observer) {
              _this.observer.disconnect();
            }
          });
        }, {
          threshold: this.threshold,
          rootMargin: '-5% 0px'
        });
        this.observer.observe(this.$refs.enterAnimItem);
      }
    }
  }
};